import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative area-size" }

import { computed, ref } from "vue";
import { layout_bounds } from "@/keyboard/layout";
import { useLayoutStore } from "@/stores";
import { useScreenSize } from "@/composables";


export default /*@__PURE__*/_defineComponent({
  __name: 'KeysLayout',
  props: {
    height: {},
    width: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "654ea552": (area_width.value + "px"),
  "e15adc4a": (area_height.value + "px")
}))

const props = __props;

const layout = useLayoutStore();
const screenSize = useScreenSize();

// TODO: cannot decrease width too much, think of a better solution for mobile screens
const defaultHeight = ref(3000); // don't care as keyboard width is bigger than height
const defaultWidth = computed(() =>
  screenSize.value == "desktop" ? 1200 : 1000
);

const keys = computed(() => {
  const transform = layout.layout.fit_size({
    x: props.width ?? defaultWidth.value,
    y: props.height ?? defaultHeight.value,
  });
  return layout.layout.iter_transform(transform);
});

const area_size = computed(() => {
  const [area_min, area_max] = layout_bounds(keys.value);
  const area_width = area_max.x - area_min.x;
  const area_height = area_max.y - area_min.y;
  return {
    x: area_width,
    y: area_height,
  };
});

const area_width = computed(() => area_size.value.x);
const area_height = computed(() => area_size.value.y);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", { keys: keys.value })
  ]))
}
}

})